export enum AdmissionTypeEnums {
  HOSPITAL = "hospital",
  COMMUNITY = "community-home",
  OTHER = "other",
}

export const admissionTypeLabelMap: Record<string, string> = {
  [AdmissionTypeEnums.HOSPITAL]: "Hospital",
  [AdmissionTypeEnums.COMMUNITY]: "Community or Home",
  [AdmissionTypeEnums.OTHER]: "Other",
};

export const admissionTypeOptions = Object.values(AdmissionTypeEnums).map(
  (value) => ({
    label: admissionTypeLabelMap[value] || value,
    value,
  }),
);
